import { Component } from 'shimmer'

import gsap from 'gsap'
import { Color } from 'three'

// state
// 0 -> desactivate
// 1 -> active
// 2 -> over
// 3 -> true
// 4 -> false

export class Bumper extends Component {
  constructor (obj, index, over) {
    super('Bumper')
    // this.meshes(0) is gonna be coloring colomn
    this.meshes = obj
    this.index = index
    this.over = over
    this.onClick = this.onClick.bind(this)
    this.baseColor = this.meshes[0].material.color.clone()

    this._isOver = false
    this.basePos = this.meshes.map(mesh => {
      return mesh.position.clone()
    })

    setTimeout(() => {
      this.state = 0
    }, 3000)
  }

  onUpdate () {
    this.isOver = this.over(this.meshes)
  }

  set state (state) {
    this._state = state

    if (this._state === 0) {
      this.goToState(-.01, new Color(0x757575))
    }
    else if (this._state === 1) {
      this.goToState(0, this.baseColor)
    }
    else if (this._state === 2) {
      this.goToState(.005, this.baseColor, true)
    }
    else if (this._state === 3) {
      this.goToState(.0, new Color(0x66d22e))
    }
    else if (this._state === 4) {
      this.goToState(.0, new Color(0xff2626))
    }
  }

  goToState (yTarget, colorTarget, fast = false) {
    const duration = fast ? .3 : .5
    this.meshes.forEach((mesh, index) => {
      gsap.to(mesh.position, {
        y: this.basePos[index].y + yTarget,
        duration: duration,
        ease: 'power3.inOut'
      })
    })

    gsap.to(this.meshes[0].material.color, {
      r: colorTarget.r,
      g: colorTarget.g,
      b: colorTarget.b,
      duration: duration,
      ease: 'power3.inOut'
    })
  }

  onClick () {
    if (this.isOver && this.state !== 0) {
      this.callbackClick(this.index)
    }
  }

  set click (payload) {
    this.callbackClick = payload
  }

  get state () {
    return this._state
  }

  set isOver (isOver) {
    if (this.isOverable) {
      this._isOver = isOver

      if (isOver && this.state === 1) {
        this.state = 2
      }

      else if (!isOver && this.state === 2) {
        this.state = 1
      }
    }
    else {
      this._isOver = false
    }
  }

  get isOver () {
    return this._isOver
  }

  get isOverable () {
    return this.state === 1 || this.state === 2
  }
}